import { FormControl, MenuItem, Select, Typography } from "@mui/material";

import Svg, {
  SvgEnum,
} from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

const noteTypes = [
  { id: 1, label: "Internal", booleanVal: true },
  { id: 2, label: "External", booleanVal: false },
];

export default function NoteTypeSelector({
  selectedNoteType,
  setSelectedNoteType,
  hideSelector = false,
  hideVisibilityInfo = false,
}) {
  const handleDropdownChange = (value) => {
    setSelectedNoteType(value);
  };

  const visibilityText = selectedNoteType ? "Internal Personnel Only" : "everyone";
  const changeText = selectedNoteType ? "External" : "Internal";

  if (hideSelector && hideVisibilityInfo) {
    return null;
  }

  return (
    <div className="flex flex-row gap-4 w-full mt-4">
      {!hideSelector && (
        <FormControl className="w-1/3">
          <Select
            fullWidth
            value={selectedNoteType}
            onChange={(e) => handleDropdownChange(e.target.value)}
            className="rounded-[8px] font-normal text-base"
            sx={{
              color: HNSColors.neutrals[500],
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: HNSColors.neutrals[500],
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: HNSColors.primary[500],
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: HNSColors.primary[500],
              },
            }}
          >
            {noteTypes.map((noteType) => (
              <MenuItem key={noteType.id} value={noteType.booleanVal}>
                {noteType.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {!hideVisibilityInfo ? (
        <div className="flex-1 flex flex-row gap-2 justify-start items-center">
          <Svg
            name={SvgEnum.HisInfo}
            sx={{ height: "24px", width: "24px" }}
            color={HNSColors.primary[500]}
          />
          <Typography
            className="flex-1 font-normal text-base"
            style={{ color: HNSColors.neutrals[300] }}
          >
            This note will be seen by{" "}
            <span className="font-semibold">{visibilityText}</span>
            {!hideSelector && <>. To change the visibility select {changeText}.</>}
          </Typography>
        </div>
      ) : null}
    </div>
  );
}
